module.exports = __webpack_public_path__ + "img/reboot.f37d7867.svg";